export const coupon = {
    coupon: 'คูปอง',
    advanceFilter: 'ตัวกรองขั้นสูง',
    search: 'ค้นหา',
    couponCondition: 'เงื่อนไขคูปอง',
    name: 'ชื่อ',
    amount: 'จำนวนเงิน',
    maxAmount: 'จำนวนเงินสูงสุด',
    type: 'ประเภท',
    source: 'แหล่งที่มา',
    turnover: 'ยอดเทิร์นโอเวอร์',
    turnoverSetting: 'การตั้งค่ายอดเทิร์นโอเวอร์',
    createdAt: 'สร้างเมื่อ',
    expiredAt: 'วันหมดอายุ',
    add: 'เพิ่ม',
    createCouponCondition: 'สร้างเงื่อนไขคูปอง',
    cancel: 'ยกเลิก',
    isActive: 'เปิดใช้งาน',
    campaign: 'แคมเปญ',
    generate: 'สร้างรหัส',
    update: 'อัปเดต',
    viewCoupon: 'ดูคูปอง',
    code: 'รหัส',
    used: 'สามารถใช้ได้',
    userId: 'รหัสผู้ใช้',
    updateCouponCondition: 'อัปเดตเงื่อนไขคูปอง',
    length: 'ความยาวตัวอักษรของรหัสคูปอง',
    description: 'คำอธิบาย',
    bonusAmount: 'จำนวนโบนัส (เป็นสตางค์หรือเปอร์เซ็นต์)',
    bonusCap: 'ขีดจำกัดโบนัส (เป็นสตางค์)',
    turnoverValue: 'ค่ายอดเทิร์นโอเวอร์ (เป็นสตางค์หรือเปอร์เซ็นต์)',
    bonusType: 'ประเภทโบนัส',
    depositType: 'ประเภทการฝาก',
    depositMinimum: 'จำนวนขั้นต่ำในการฝาก',
    limitUsePerUser: 'จำกัดการใช้งานต่อผู้ใช้',
    limitUsePerUserPerDay: 'จำกัดการใช้งานต่อผู้ใช้ต่อวัน',
    limitUsePerCampaign: 'จำกัดการใช้งานต่อแคมเปญ',
    newUserDuration: 'ระยะเวลาผู้ใช้ใหม่ (ชั่วโมง)',
    create: 'สร้าง',
    expireHour: 'คูปองจะหมดอายุภายในกี่ชั่วโมง (0 = ไม่มีวันหมดอายุ)',
    
    // Bonus Type Options
    fix_amount: 'จำนวนคงที่',
    fixed_amount: 'จำนวนคงที่',
    deposit_percent: 'เปอร์เซ็นต์ของการฝาก',
    valid_balance_percent: 'เปอร์เซ็นต์ของยอดคงเหลือ',
    
    // Deposit Type Options
    none: 'ไม่มี',
    single_time_latest: 'ล่าสุด (ใช้สิทธิ์ได้ครั้งเดียว)',
    multiple_time_latest: 'ล่าสุด (ใช้สิทธิ์ได้หลายครั้ง)',
    cumulative: 'สะสม',
    
    // Turnover Options
    bonus_percent: 'เปอร์เซ็นต์ของโบนัส',
    couponAmount: 'จำนวนคูปอง',
    couponMode: 'ประเภทของคูปอง',
    generic: 'ใช้ซ้ำได้',
    unique: 'ใช้ครั้งเดียว',

    // Period Deposit Type
    period: 'จำกัดช่วงเวลา',
    depositPeriodStart: 'วันและเวลาที่เริ่มฝากเงิน',
    depositPeriodEnd: 'วันและเวลาที่จบฝากเงิน',

    // Schedule
    hasSchedule: 'ตั้งเวลา',
    scheduleStartDate: 'เริ่มวันที่',
    scheduleEndDate: 'จบวันที่',
    scheduleAllDay: 'ตลอดทั้งวัน',
    scheduleStartTime: 'เริ่มเวลา',
    scheduleEndTime: 'จบเวลา',
    scheduleRepeatEvery: 'ใช้งานได้ทุกๆ',
    scheduleDaysOfWeek: 'วันในสัปดาห์',
    repeatUnit_none: 'ไม่มี',
    repeatUnit_day: 'วัน',
    repeatUnit_week: 'สัปดาห์',
    repeatUnit_month: 'เดือน',
    day_sun: 'อา',
    day_mon: 'จ',
    day_tue: 'อ',
    day_wed: 'พ',
    day_thu: 'พฤ',
    day_fri: 'ศ',
    day_sat: 'ส',
    scheduleEndDateError: 'วันที่สิ้นสุดต้องมากกว่าวันที่เริ่มต้นอย่างน้อย 1 เดือน',
    scheduleMonthMode_byDate: 'ตามวันที่',
    scheduleMonthMode_byWeekday: 'ตามวันในสัปดาห์',
    scheduleDaysOfMonth: 'วันที่ในเดือน',
    scheduleLastDay: 'วันสุดท้ายของเดือน',
    scheduleWeeksOfMonth: 'สัปดาห์ในเดือน',
    week_first: 'สัปดาห์แรก',
    week_second: 'สัปดาห์ที่สอง',
    week_third: 'สัปดาห์ที่สาม',
    week_fourth: 'สัปดาห์ที่สี่',
    week_last: 'สัปดาห์สุดท้าย',
    scheduleMonthSelectionError: 'เลือกอย่างน้อยหนึ่งวัน หากเลือกแบบวันในสัปดาห์ ให้เลือกสัปดาห์และวันอย่างน้อยหนึ่งรายการ',

}